import * as types from './mutation-types';

export default {
    [types.SET_CURRENT_CUSTOMER] (state, customer) {
        state.currentCustomer = customer;
    },
}
